// 在线预约相关路由
export default [
  {
    path: '/online-booking',
    name: 'online-booking',
    component: () => import('@/jaas/appointment/OnlineBooking.vue'),
    meta: {
      title: '帮代办专区-在线预约',
      keepAlive: true
    }
  },
  {
    path: '/assistant-record',
    name: 'assistant-record',
    component: () => import('@/jaas/appointment/AssistantRecord.vue'),
    meta: {
      title: '帮代办专区-在线预约-帮代办申请记录',
      requiresAuth: true
    }
  },
  {
    path: '/appointment-detail',
    name: 'appointment-detail',
    component: () => import('@/jaas/appointment/AppointmentDetail.vue'),
    meta: {
      title: '帮代办专区-在线预约-帮代办事项详情'
    }
  },
  {
    path: '/submit-success',
    name: 'submit-success',
    component: () => import('@/jaas/appointment/SubmitSuccess.vue'),
    meta: {
      title: '帮代办专区-在线预约-预约提交成功'
    }
  }
]
